import RagProductDetail from './includes/_rag-productdetail.class';
export default class RagProductDetailComponent extends lm.Composant {
  constructor(id) {
    super(id);
    const mainRag = document.querySelector('#rag-productdetail');
    if (mainRag) {
      const rag = new RagProductDetail(mainRag);
      rag.initRag();
    }
  }
}
lm.DOMReady(function () {
  new RagProductDetailComponent('ragproductdetail');
});